<!-- @format -->

<a
	[attr.data-em]="dataEm"
	[href]="link"
	class="hmf-p-xs">
	<homefield-product-image
		[imageUrl]="imgSrc"
		[defaultColor]="color"
		[ecode]="ecode"
		class="hmf-mb-xs hmf-mb-m-xxxs"></homefield-product-image>
	<div class="recommendation-title hmf-body-m hmf-body-l-l">{{ title }}</div>
	<div class="original-price-text">
		<span>{{
			minOriginalPrice && minPrice !== minOriginalPrice ? (minOriginalPrice | currency) : ''
		}}</span>
		@if (minOriginalPrice !== maxOriginalPrice && minPrice !== minOriginalPrice) {
			<span>&nbsp;-&nbsp;{{ maxOriginalPrice | currency }}</span>
		}
	</div>
	@if (!isSeePriceInCart) {
		<div class="discount-price-text hmf-body-bold-m hmf-body-bold-m-l">
			<span>{{ minPrice ? (minPrice | currency) : '' }}</span>
			@if (minPrice !== maxPrice) {
				<span>&nbsp;-&nbsp;{{ maxPrice | currency }}</span>
			}
		</div>
	}
	@if (isSeePriceInCart) {
		<span class="discount-price-text">See Price In Cart</span>
	}
</a>
